import styled from 'styled-components';

const UnorderedList = styled.ul.attrs({
  className: `list-disc list-inside pl-3`,
})``;

export default UnorderedList;
